import React from "react";
import { Button, Container, Stack, Typography, Grid } from "@mui/material";
import { countries } from "country-data";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { createChat, checkout } from "../../../apis";
import "../../../App.css";
import moment from "moment";

const SelectedRequest = ({ currentRequest, viewOnly }) => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user-info"));
  const userid = user.googleId ? user.googleId : user._id;

  const AcceptOfferHandler = async () => {
    // navigate("/payment-method", { state: { currentRequest } });
    const response = await checkout({
      name: currentRequest.serviceProviderName,
      price: currentRequest.price,
      requestId: currentRequest.requestId,
      currentRequestId: currentRequest._id,
    });
    window.location.href = response.data.session;
  };
  const SendMessageHandler = async () => {
    await createChat({
      senderId: userid,
      receiverId: currentRequest.serviceProviderId,
    });
    navigate("/chat");
  };
  return (
    <>
      <Container
        style={{ background: "#FAFBFE", height: "100vh", paddingRight: "70px" }}
      >
        <Stack>
          <h2>Quote Details</h2>
        </Stack>

        <Grid container>
          <Grid item sm={2}>
            <AccountCircleIcon
              style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
            />
          </Grid>
          <Grid item sm={10}>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  className="mb-5"
                >
                  <Typography style={{ fontWeight: "bold" }}>
                    {currentRequest.serviceProviderName}
                  </Typography>
                  <CheckCircleIcon
                    style={{ height: "15px", width: "15px", color: "#FA8319" }}
                  />
                </Stack>
                <Stack
                  style={{
                    padding: "3px",
                    borderRadius: "4px",
                    backgroundColor: "rgba(52, 168, 83, 0.3)",
                    width: "55px",
                  }}
                  spacing={1}
                  direction="row"
                  alignItems="center"
                  className="mb-5"
                >
                  <StarIcon
                    style={{
                      height: "18px",
                      width: "18px",
                      color: "rgba(52, 168, 83, 1)",
                    }}
                  />
                  <Typography style={{ color: "rgba(52, 168, 83, 1)" }}>
                    4.0
                  </Typography>
                </Stack>
                <h4>Expert Location</h4>
                <Typography
                  className="mb-5"
                  style={{ color: "rgba(122, 122, 128, 1)" }}
                >
                  {countries[currentRequest.serviceProviderCountry].name}
                </Typography>
              </Stack>

              <div
                style={{ background: "white", padding: "20px", width: "200px" }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{ marginBottom: "20px" }}
                >
                  <Typography style={{ color: "#7A7A80" }}>
                    Price Offered
                  </Typography>
                  <Typography style={{ fontWeight: "bold" }}>
                    £{currentRequest.price}
                  </Typography>
                </Stack>
                <Stack spacing={2} alignItems="center">
                  {viewOnly ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        className="primary-button"
                        style={{
                          textTransform: "capitalize",
                          width: "168px",
                        }}
                        onClick={AcceptOfferHandler}
                      >
                        Accept Offer
                      </Button>
                      <Button
                        variant="outlined"
                        className="default-border default-color"
                        style={{ textTransform: "capitalize", width: "168px" }}
                        onClick={SendMessageHandler}
                      >
                        Send Message
                      </Button>
                    </>
                  )}
                </Stack>
              </div>
            </Stack>

            <Stack>
              <h4>Details</h4>
              {currentRequest.offerType == "staged" ? (
                <>
                  {currentRequest.StageData.map((item) => (
                    <Grid container>
                      <Grid item sm={4}>
                        <Typography style={{ fontWeight: "bold" }}>
                          Detail
                        </Typography>
                        <Typography className="ammanat-darker-gray">
                          {item.stageDetail}
                        </Typography>
                      </Grid>
                      <Grid item sm={4}>
                        <Typography style={{ fontWeight: "bold" }}>
                          Price
                        </Typography>
                        <Typography className="ammanat-darker-gray">
                          {item.price}
                        </Typography>
                      </Grid>
                      <Grid item sm={4}>
                        <Typography style={{ fontWeight: "bold" }}>
                          Due Date
                        </Typography>
                        <Typography className="ammanat-darker-gray">
                          {moment(item.dueDate).utc().format("MMMM Do, YYYY")}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </>
              ) : (
                <Typography
                  variant="body1"
                  style={{ color: "rgba(122, 122, 128, 1)" }}
                >
                  {currentRequest.offerDetails}
                </Typography>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SelectedRequest;
